"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var __jsx = _react["default"].createElement;
var ArrowBackIcon = function ArrowBackIcon(props) {
  return __jsx("svg", props, __jsx("path", {
    d: "M4.883 13.438l6.542 6.99-.876.82-7.87-8.41 7.87-8.41.876.82-6.542 6.99H20.5v1.2H4.883z"
  }));
};
ArrowBackIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
var ReturnText = function ReturnText(props) {
  var label = props.label,
    onClick = props.onClick;
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
    onClick: onClick
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      height: "24px",
      svg: {
        transform: "scaleX(0.5) scaleY(0.5)"
      }
    }
  }, __jsx(ArrowBackIcon, null)), __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "xs",
      color: "main"
    }
  }, label));
};
var _default = ReturnText;
exports["default"] = _default;